import { onCleanup } from 'solid-js';

export function clickOutside(el: HTMLElement, fn: () => void) {
  const listener = (e: MouseEvent) => {
    if (!el.contains(e.target as Node)) {
      fn();
    }
  };
  document.addEventListener('click', listener);
  onCleanup(() => document.removeEventListener('click', listener));
}
